export default __webpack_public_path__ + "static/media/add-new-contract.f04949e5.png";